/* */ 
"use strict";
var core_1 = require('@angular/core');
var lang_1 = require('../facade/lang');
var async_1 = require('../facade/async');
var invalid_pipe_argument_exception_1 = require('./invalid_pipe_argument_exception');
var ObservableStrategy = (function() {
  function ObservableStrategy() {}
  ObservableStrategy.prototype.createSubscription = function(async, updateLatestValue) {
    return async_1.ObservableWrapper.subscribe(async, updateLatestValue, function(e) {
      throw e;
    });
  };
  ObservableStrategy.prototype.dispose = function(subscription) {
    async_1.ObservableWrapper.dispose(subscription);
  };
  ObservableStrategy.prototype.onDestroy = function(subscription) {
    async_1.ObservableWrapper.dispose(subscription);
  };
  return ObservableStrategy;
}());
var PromiseStrategy = (function() {
  function PromiseStrategy() {}
  PromiseStrategy.prototype.createSubscription = function(async, updateLatestValue) {
    return async.then(updateLatestValue);
  };
  PromiseStrategy.prototype.dispose = function(subscription) {};
  PromiseStrategy.prototype.onDestroy = function(subscription) {};
  return PromiseStrategy;
}());
var _promiseStrategy = new PromiseStrategy();
var _observableStrategy = new ObservableStrategy();
var __unused;
var AsyncPipe = (function() {
  function AsyncPipe(_ref) {
    this._latestValue = null;
    this._latestReturnedValue = null;
    this._subscription = null;
    this._obj = null;
    this._strategy = null;
    this._ref = _ref;
  }
  AsyncPipe.prototype.ngOnDestroy = function() {
    if (lang_1.isPresent(this._subscription)) {
      this._dispose();
    }
  };
  AsyncPipe.prototype.transform = function(obj) {
    if (lang_1.isBlank(this._obj)) {
      if (lang_1.isPresent(obj)) {
        this._subscribe(obj);
      }
      this._latestReturnedValue = this._latestValue;
      return this._latestValue;
    }
    if (obj !== this._obj) {
      this._dispose();
      return this.transform(obj);
    }
    if (this._latestValue === this._latestReturnedValue) {
      return this._latestReturnedValue;
    } else {
      this._latestReturnedValue = this._latestValue;
      return core_1.WrappedValue.wrap(this._latestValue);
    }
  };
  AsyncPipe.prototype._subscribe = function(obj) {
    var _this = this;
    this._obj = obj;
    this._strategy = this._selectStrategy(obj);
    this._subscription = this._strategy.createSubscription(obj, function(value) {
      return _this._updateLatestValue(obj, value);
    });
  };
  AsyncPipe.prototype._selectStrategy = function(obj) {
    if (lang_1.isPromise(obj)) {
      return _promiseStrategy;
    } else if (async_1.ObservableWrapper.isObservable(obj)) {
      return _observableStrategy;
    } else {
      throw new invalid_pipe_argument_exception_1.InvalidPipeArgumentException(AsyncPipe, obj);
    }
  };
  AsyncPipe.prototype._dispose = function() {
    this._strategy.dispose(this._subscription);
    this._latestValue = null;
    this._latestReturnedValue = null;
    this._subscription = null;
    this._obj = null;
  };
  AsyncPipe.prototype._updateLatestValue = function(async, value) {
    if (async === this._obj) {
      this._latestValue = value;
      this._ref.markForCheck();
    }
  };
  AsyncPipe.decorators = [{
    type: core_1.Pipe,
    args: [{
      name: 'async',
      pure: false
    }]
  }, {type: core_1.Injectable}];
  AsyncPipe.ctorParameters = [{type: core_1.ChangeDetectorRef}];
  return AsyncPipe;
}());
exports.AsyncPipe = AsyncPipe;
